/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  Divider,
  Fade,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Pagination,
  Paper,
  Popper,
  Skeleton,
  styled,
  Switch,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { colors, fonts, size } from "../ColorFont/color";
import Carousel from "react-material-ui-carousel";
import AddPlots from "../components/AddPlots";
import AddIcon from "@mui/icons-material/Add";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { CitySelect, StateSelect } from "react-country-state-city";
import {
  Call,
  Campaign,
  Close,
  Edit,
  Favorite,
  FavoriteBorder,
  GetApp,
  SubdirectoryArrowRight,
  Tune,
} from "@mui/icons-material";
import ContactPopup from "../components/ViewDetails";
import EditPlot from "./EditPlot";
import { admin, url } from "../ConstUrl/Url";
import SignUp from "../auth/SignUp";
import SponsoredHoursPopup from "./SponsoredHoursPopup";
import { useTranslation } from "react-i18next";
import { KrushiSetu } from "../constants/constant";
import UnifiedCropCard from "../components/UnifiedCropCard";

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const ListPlots = ({ userData, setUserData, handleUpgradePlans }) => {
  const role = userData?.role;
  const userId = userData?._id;
  const email = userData?.email;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  // const URI = "${url}";

  const [editPlot, setEditPlot] = useState(null);
  const [wishlist, setWishlist] = useState(userData?.wishlist);
  const [isChange, setIsChange] = useState(false);
  const [addPlots, setAddPlots] = useState(false);
  const [showBtn, setShowBtn] = useState(true);
  const [showCard, setShowCard] = useState(true);
  const [plots, setPlots] = useState([]);
  const [isSeller, setIsSeller] = useState(false);
  const [isBuyer, setIsBuyer] = useState(false);
  const [filterCategory, setFilterCategory] = useState([]);
  const [filterSubCategory, setFilterSubCategory] = useState([]);
  const [countryid, setCountryid] = useState(101);
  const [stateid, setstateid] = useState(0);
  const [state, setState] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [tehsil, setTehsil] = useState("");
  const [page, setPage] = useState(1);
  const [pageData, setPageData] = useState(null);
  const [sortBy, setSortBy] = useState("");
  const [available, setAvailable] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [isUpgradePopupOpen, setOpenUpgradePopup] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [plotDetails, setPlotDetails] = useState();
  const [isModalClosed, setIsModalClosed] = useState(false);
  const [openSponsoredHoursPopup, setOpenSponsoredHoursPopup] = useState(false);
  const [sponsoredHoursRemaining, setSponsoredHoursRemaining] = useState(0);
  const [plotTimers, setPlotTimers] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState();
  const [showResult, setShowResult] = useState(false);
  // const [clearFilter, setClearFilter] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(""); // Selected category
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]); // To store fetched categories
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [disabledPlots, setDisabledPlots] = useState({});
  const [displayCat, setDisplayCat] = useState(false);
  const [displayCity, setDisplayCity] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [openLogin, setOpenLogin] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [prevFilterStatus, setPrevFilterStatus] = useState("");
  const [showResultsClicked, setShowResultsClicked] = useState(false);
  const [statusClicked, setStatusClicked] = useState(false);

  useEffect(() => {
    fetch(`${url}/api/get-categories`)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => console.error(error));
  }, []);
  const handleOpen = () => {
    setOpenLogin(true);
  };
  useEffect(() => {
    if (userData) {
      handleClose();
    }
  }, [userId]);
  const handleClose = () => {
    setOpenLogin(false);
  };
  useEffect(() => {
    if (selectedCategory) {
      const category = categories.find(
        (category) => category.categoryType === selectedCategory
      );
      if (category) {
        setSubCategories(category.subCategories);
      }
    }
  }, [selectedCategory]);

  const handleCancel = () => {
    setDisplayCity(false);
    setDisplayCat(false);
    setOpen(false);
  };
  useEffect(() => {
    setPrevFilterStatus(filterStatus);
  }, [filterStatus]);
  const handleDisable = (plotId, isDisabled) => {
    setDisabledPlots((prevDisabledPlots) => ({
      ...prevDisabledPlots,
      [plotId]: isDisabled,
    }));

    fetch(`${url}/api/plots/${plotId}/disable`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ isDisabled }),
    })
      .then((response) => response.json())
      .then((data) => console.log(data))
      .catch((error) => console.error(error));
  };
  const handleClick = (newPlacement) => (event) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => placement !== newPlacement || !prev);
    setPlacement(newPlacement);
  };

  const handleClearFilter = (event) => {
    setShowResult(true);
    setDisplayCity(false);

    setDisplayCat(false);
    setFilterCategory([]);
    setFilterSubCategory([]);
    setState("");
    setTehsil("");
    setSelectedCategory("");
    setSelectedSubCategory("");
    setPage(1);
    setSortBy("");
    setFilterStatus("");
    setstateid(0);
  };

  const handleAddPlotClick = () => {
    setAddPlots(true);
    setShowBtn(false);
    setShowCard(false);
    setShowDetails(true);
  };

  const handleShowResult = () => {
    setShowResult(true);
    setShowResultsClicked(true);

    if (selectedCategory && selectedSubCategory) {
      setFilterCategory([selectedCategory]);
      setFilterSubCategory(selectedSubCategory);
    } else if (selectedCategory) {
      setFilterCategory([selectedCategory]);
    } else if (selectedSubCategory) {
      setFilterSubCategory(selectedSubCategory);
    }
    setPage(1);
    setFilterStatus(filterStatus);
  };

  // Fetch data from the backend
  useEffect(() => {
    // Construct the URL dynamically
    // let URI = `${url}/api/plots?category=${filterCategory.join(",")}&state=${state}&tehsil=${tehsil}&page=${page}&sortby=${sortBy}`;
    let URI = `${url}/api/plots?category=${filterCategory.join(",")}&subCategory=${filterSubCategory}&state=${state}&tehsil=${tehsil}&page=${page}&sortby=${sortBy}&status=${filterStatus}`;

    if (email == `${admin}`) {
      URI += `&disabled=true&disabled=false`;
    } else if (role == "Seller") {
      setIsSeller(true);

      console.log("Seller", role);
      URI += `&user=${userId}&disabled=true&disabled=false`;
    } else if (role == "Buyer") {
      setIsBuyer(true);

      URI += `&disabled=false`;
    } else {
      URI += `&disabled=false`;
    }
    if (sortBy === "sponsoredHoursRemaining") {
      URI += `&sponsoredHoursRemaining=true`;
    }

    //filter data according to category
    fetch(URI)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Failed to fetch plots.");
        }
      })
      .then((data) => {
        setPlots(data.paginatedPlots);
        setPageData(data);
      })
      .catch((error) => console.error(error));
    setIsModalClosed(false);
    if (showResultsClicked) {
      setShowResultsClicked(false);
    }
  }, [
    filterCategory,
    filterSubCategory,
    // state,
    // tehsil,
    page,
    // sortBy,
    available,
    userData,
    isModalClosed,
    showResult,
    disabledPlots,
    isRender,
    statusClicked,
    // filterStatus,
    showResultsClicked,
  ]);

  const handleUpdatePlot = (updatedPlot) => {
    setPlots((prevPlots) =>
      prevPlots.map((plot) =>
        plot._id === updatedPlot._id ? { ...plot, ...updatedPlot } : plot
      )
    );
  };
  const handleWishlist = (plotId) => {
    const action = wishlist?.includes(plotId) ? "remove" : "add";
    fetch(`${url}/api/wishlist`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userData?._id,
        plotId,
        action,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (action === "add") {
          setWishlist([...wishlist, plotId]);
        } else {
          setWishlist(wishlist.filter((id) => id !== plotId));
        }
      })
      .catch((error) => console.error(error));
  };

  const handleToast = (message) => {
    setToastMessage(message);
    setOpenToast(true);
  };

  const handleActivePlot = (plotId, isAvailable) => {
    fetch(`${url}/api/update-plot`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: userData._id,
        plotId,
        isAvailable: !isAvailable,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setAvailable(!available);
      })
      .catch((error) => console.error(error));
  };

  const handleGetContact = (plot) => {
    const userId = userData?._id;
    const plotId = plot?._id;

    if (!userData) {
      handleOpen();
      return;
    } else if (userData.noOfContacts <= 0) {
      // If no contacts and plot details are not already viewed, show upgrade popup
      if (
        !userData?.purchasedPlots?.some(
          (purchasedPlot) => purchasedPlot.plotId === plotId
        )
      ) {
        setOpenUpgradePopup(true);
        return;
      }
    }

    fetch(`${url}/api/view-plot-details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        plotId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Plot details already viewed") {
          setSelectedPlot(plot);
          setOpenPopup(true);
        } else {
          // Decrement noOfContacts and update userData
          setUserData(data.user);
          setSelectedPlot(plot);
          setOpenPopup(true);
        }
      })
      .catch((error) => console.error(error));
  };

  // pagination
  const handleChange = (event, value) => {
    setPage(value);
  };

  // edit form function

  const handleEditPlot = (plot) => {
    console.log("plot details after click on edit plot", plot);
    setEditPlot(plot);
    setPlotDetails(plot);

    setOpenEditModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setIsModalClosed((prev) => !prev);
  };
  const handleSortStatus = (event) => {
    const {
      target: { value },
    } = event;
    setStatusClicked(true);
    setPage(1);
    setFilterStatus(value);
  };
  const handleSort = (event) => {
    const {
      target: { value },
    } = event;
    setSortBy(value);
    setPage(1);
  };

  const handleUpdateSponsoredHours = (plot, sponsoredHoursRemaining) => {
    fetch(`${url}/api/update/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        plotId: plot._id,
        sponsoredHoursRemaining,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Sponsored hours updated successfully") {
          setSponsoredHoursRemaining(sponsoredHoursRemaining);
        }
      })
      .catch((error) => console.error(error));
  };

  const Timer = () => {
    const [time, setTime] = useState(sponsoredHoursRemaining * 60 * 60); // convert hours to seconds

    const intervalIdRef = useRef(null);

    useEffect(() => {
      const id = setInterval(() => {
        setTime((prevTime) => {
          if (prevTime <= 0) {
            clearInterval(id);
            handleUpdateSponsoredHours(plots, 0);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      intervalIdRef.current = id;

      return () => clearInterval(id);
    }, []);

    const handleStopTimer = () => {
      clearInterval(intervalIdRef.current);
      const remainingHours = Math.floor(time / 3600);
      handleUpdateSponsoredHours(plots, remainingHours);
    };

    return (
      <div>
        <h2> Sponsored Hours Remaining: {formatTime(time)} </h2>
        <button onClick={handleStopTimer}>Stop Timer</button>
      </div>
    );
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    fetch(`${url}/api/get-sponsor-hours`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSponsoredHoursRemaining(data.sponsoredHoursRemaining);
      })
      .catch((error) => console.error(error));
  }, []);

  const handleAssignSponsoredHours = (plot) => {
    setOpenSponsoredHoursPopup(true);
    setSelectedPlot(plot);
  };
  const handleUpdateUser = (newUserData) => {
    setUserData(newUserData);
  };

  // ***********************************************************************************************
  useEffect(() => {
    const timers = {};
    plots.forEach((plot) => {
      if (plot.sponsoredHoursRemaining > 0) {
        const timer = setInterval(() => {
          const remainingHours = plot.sponsoredHoursRemaining - 1;
          if (remainingHours > 0) {
            setPlotTimers((prevTimers) => ({
              ...prevTimers,
              [plot._id]: remainingHours,
            }));
          } else {
            clearInterval(timer);
          }
        }, 3600000); // 1 hour interval
        timers[plot._id] = timer;
      }
    });
    return () => {
      Object.values(timers).forEach((timer) => clearInterval(timer));
    };
  }, [plots]);

  const UpgradePlanPopup = ({ onClose }) => {
    const [open, setOpen] = useState(true);

    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 400,
      bgcolor: "background.paper",
      border: "2px solid #000",
      boxShadow: 24,
      p: 4,
    };

    return (
      <Modal open={open} onClose={onClose}>
        <Box sx={{ ...style, p: 4, borderRadius: 3, maxWidth: 400 }}>
          <Card sx={{ boxShadow: 4, p: 3 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                sx={{
                  fontFamily: fonts.poppins,
                  fontWeight: 600,
                  color: colors.primary_dark,
                  fontSize: size.title,
                }}
              >
                Upgrade Your Plan
              </Typography>
              <Button onClick={onClose} sx={{ minWidth: "auto", p: 0 }}>
                <Close sx={{ color: colors.primary_dark }} />
              </Button>
            </Box>
            <Typography
              sx={{ mb: 3, fontFamily: fonts.poppins, color: colors.text }}
            >
              You need to purchase a plan to view plot contact details.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button
                onClick={handleUpgradePlans}
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: 2,
                  backgroundImage: colors.button,
                  fontSize: size.formLabel,
                  padding: "8px 20px",
                  textTransform: "none",
                }}
              >
                Upgrade Plan
              </Button>
            </Box>
          </Card>
        </Box>
      </Modal>
    );
  };
  return (
    <Box sx={{ background: colors.background3, px: 0 }}>
      {isUpgradePopupOpen && (
        <UpgradePlanPopup onClose={() => setOpenUpgradePopup(false)} />
      )}
      <Box sx={{ margin: "0 auto", maxWidth: "1200px", px: 0 }}>
        {userData?.email === `${admin}` && (
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: fonts.poppins,
                fontWeight: 800,
                color: colors.primary_dark,
                mb: 1,
              }}
            >
              List of Crops
            </Typography>
            <Typography
              sx={{
                fontFamily: fonts.poppins,
                color: colors.text,
                fontSize: "1rem",
              }}
            >
              Review, enable, or disable crop listings across the platform.
            </Typography>
          </Box>
        )}

        {isSeller && showBtn && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontFamily: fonts.poppins,
                fontSize: size.title,
                fontWeight: 600,
                color: colors.primary_dark,
              }}
            >
              {t("YourPlots")}
            </Typography>
            <Typography sx={{ fontFamily: fonts.poppins }}>
              {sponsoredHoursRemaining > 0 && <Timer />}
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundImage: colors.button,
                    fontFamily: fonts.poppins,
                    padding: "8px 20px",
                    fontSize: size.formLabel,
                    textTransform: "none", // Prevents automatic uppercase transformation
                    borderRadius: 2,
                  }}
                  startIcon={
                    <AddIcon sx={{ fontSize: "small", color: "white" }} />
                  }
                  onClick={handleAddPlotClick}
                >
                  {t("addPlot")} {/* Now in lowercase */}
                </Button>
              </Box>
            </Box>
          </Box>
        )}

        {addPlots && (
          <AddPlots
            setShowBtn={setShowBtn}
            setShowCard={setShowCard}
            setAddPlots={setAddPlots}
            userData={userData}
            setIsRender={setIsRender}

            // onClose={onClose}
          />
        )}
      </Box>

      {showCard && (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                position: "relative",
              }}
            >
              {open && (
                <Box
                  sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.4)", // Gray backdrop
                    zIndex: 1299,
                  }}
                />
              )}
              <Popper
                sx={{
                  zIndex: 1300,
                  width: isMobile ? "90vw" : "700px",
                  maxWidth: isMobile ? "400px" : "none",
                }}
                open={open}
                anchorEl={anchorEl}
                placement={isMobile ? "bottom" : placement}
                transition
              >
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={300}>
                    <Paper
                      elevation={10}
                      sx={{
                        borderRadius: "20px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.15)",
                        p: isMobile ? "10px" : "16px",
                        width: "100%",
                      }}
                    >
                      {/* Header: Cancel & Reset */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: isMobile ? 2 : 3,
                        }}
                      >
                        <Typography
                          onClick={handleCancel}
                          sx={{
                            cursor: "pointer",
                            fontWeight: 600,
                            color: "#FF4D4D",
                            fontFamily: fonts.poppins,
                            transition: "all 0.3s",
                            fontSize: isMobile ? "0.9rem" : "1rem",
                            "&:hover": {
                              color: "#D32F2F",
                              transform: "scale(1.05)",
                            },
                          }}
                        >
                          ✖ {t("cancel")}
                        </Typography>
                        <Typography
                          onClick={handleClearFilter}
                          sx={{
                            cursor: "pointer",
                            fontWeight: 600,
                            color: "#1976D2",
                            fontFamily: fonts.poppins,
                            transition: "all 0.3s",
                            fontSize: isMobile ? "0.9rem" : "1rem",
                            "&:hover": {
                              color: "#1565C0",
                              transform: "scale(1.05)",
                            },
                          }}
                        >
                          🔄 {t("reset")}
                        </Typography>
                      </Box>

                      <Divider sx={{ mb: 2, marginTop: isMobile ? -1 : -2 }} />

                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                          gap: isMobile ? 2 : 3,
                        }}
                      >
                        {/* State Selection */}
                        <FormControl
                          size={isMobile ? "small" : "small"}
                          fullWidth
                        >
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: colors.text,
                              mb: 1,
                              fontFamily: fonts.poppins,
                              fontSize: isMobile ? "0.9rem" : "1rem",
                            }}
                          >
                            {t("state")}
                          </Typography>
                          <StateSelect
                            countryid={countryid}
                            onChange={(e) => {
                              setState(e.name);
                              setstateid(e.id);
                              setPage(1);
                            }}
                            onClick={() => setDisplayCity(true)}
                            placeHolder={t("selectState")}
                            required
                          />
                        </FormControl>

                        {/* Taluka (CitySelect) - Disabled Until State is Selected */}
                        <FormControl
                          size={isMobile ? "small" : "small"}
                          fullWidth
                        >
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: colors.text,
                              mb: 1,
                              fontFamily: fonts.poppins,
                              fontSize: isMobile ? "0.9rem" : "1rem",
                            }}
                          >
                            {t("tahsil")}
                          </Typography>

                          {stateid ? (
                            <CitySelect
                              countryid={countryid}
                              stateid={stateid}
                              onChange={(e) => {
                                setTehsil(e.name);
                                setPage(1);
                              }}
                              placeHolder={t("selectTahsil")}
                              required
                            />
                          ) : (
                            <TextField
                              size={isMobile ? "small" : "small"}
                              fullWidth
                              placeholder={t("selectStateFirst")}
                              disabled
                            />
                          )}
                        </FormControl>

                        {/* Category */}
                        <FormControl
                          size={isMobile ? "small" : "small"}
                          fullWidth
                        >
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: colors.text,
                              mb: 1,
                              fontFamily: fonts.poppins,
                              fontSize: isMobile ? "0.9rem" : "1rem",
                            }}
                          >
                            {t("category")}
                          </Typography>
                          <Select
                            size={isMobile ? "small" : "small"}
                            value={selectedCategory}
                            onChange={(event) => {
                              setSelectedCategory(event.target.value);
                              setSelectedSubCategory(""); // Reset subcategory when category changes
                            }}
                            onClick={() => setDisplayCat(true)}
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span
                                    style={{
                                      color: "#a8a8a8",
                                      fontSize: isMobile ? "0.9rem" : "1rem",
                                    }}
                                  >
                                    {t("selectCategory")}
                                  </span>
                                );
                              }
                              return selected;
                            }}
                          >
                            <MenuItem disabled value="">
                              <em
                                style={{
                                  fontSize: isMobile ? "0.9rem" : "1rem",
                                }}
                              >
                                {t("selectCategory")}
                              </em>
                            </MenuItem>
                            {categories.map((category) => (
                              <MenuItem
                                key={category._id}
                                value={category.categoryType}
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                {category.categoryType}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        {/* Sub Category */}
                        <FormControl
                          size={isMobile ? "small" : "small"}
                          fullWidth
                        >
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: colors.text,
                              mb: 1,
                              fontFamily: fonts.poppins,
                              fontSize: isMobile ? "0.9rem" : "1rem",
                            }}
                          >
                            {t("subCategory")}
                          </Typography>
                          <Select
                            size={isMobile ? "small" : "small"}
                            value={selectedSubCategory}
                            onChange={(event) =>
                              setSelectedSubCategory(event.target.value)
                            }
                            disabled={!selectedCategory}
                            displayEmpty
                            renderValue={(selected) => {
                              if (!selected) {
                                return (
                                  <span
                                    style={{
                                      color: !selectedCategory
                                        ? "#e0e0e0"
                                        : "#a8a8a8",
                                      fontSize: isMobile ? "0.9rem" : "1rem",
                                    }}
                                  >
                                    {!selectedCategory
                                      ? t("noSubCategory")
                                      : t("selectSubCategory")}
                                  </span>
                                );
                              }
                              return selected;
                            }}
                          >
                            <MenuItem disabled value="">
                              <em
                                style={{
                                  fontSize: isMobile ? "0.9rem" : "1rem",
                                }}
                              >
                                {t("selectSubCategory")}
                              </em>
                            </MenuItem>
                            {subCategories.map((subcategory) => (
                              <MenuItem
                                key={subcategory}
                                value={subcategory}
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                {subcategory}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>

                      <Grid container spacing={isMobile ? 1 : 3}>
                        {/* Status Filter */}
                        <Grid item xs={12} sm={6}>
                          <FormControl
                            size={isMobile ? "small" : "small"}
                            fullWidth
                            sx={{ marginTop: isMobile ? 2 : 3 }}
                          >
                            <Typography
                              sx={{
                                fontWeight: 500,
                                color: colors.text,
                                mb: 1,
                                fontFamily: fonts.poppins,
                                fontSize: isMobile ? "0.9rem" : "1rem",
                              }}
                            >
                              {t("status")}
                            </Typography>
                            <Select
                              size={isMobile ? "small" : "small"}
                              value={filterStatus}
                              onChange={handleSortStatus}
                              displayEmpty
                              renderValue={(selected) => {
                                if (!selected) {
                                  return (
                                    <span
                                      style={{
                                        color: "#a8a8a8",
                                        fontSize: isMobile ? "0.9rem" : "1rem",
                                      }}
                                    >
                                      {t("selectStatus")}
                                    </span>
                                  );
                                }
                                return selected === "sold"
                                  ? "Sold"
                                  : selected === "unsold"
                                    ? "Unsold"
                                    : "All";
                              }}
                            >
                              <MenuItem
                                disabled
                                value=""
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                <em>{t("selectStatus")}</em>
                              </MenuItem>
                              <MenuItem
                                value=""
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                {t("all")}
                              </MenuItem>
                              <MenuItem
                                value="sold"
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                {t("sold")}
                              </MenuItem>
                              <MenuItem
                                value="unsold"
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                {t("forSale")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        {/* Sort By */}
                        <Grid item xs={12} sm={6}>
                          <Typography
                            sx={{
                              fontWeight: 500,
                              color: colors.text,
                              mb: 1,
                              fontFamily: fonts.poppins,
                              marginTop: isMobile ? 2 : 3,
                              fontSize: isMobile ? "0.9rem" : "1rem",
                            }}
                          >
                            {t("sortBy")}
                          </Typography>
                          <FormControl
                            size={isMobile ? "small" : "small"}
                            fullWidth
                          >
                            <Select
                              size={isMobile ? "small" : "small"}
                              value={sortBy}
                              onChange={handleSort}
                              displayEmpty
                              renderValue={(selected) => {
                                if (!selected) {
                                  return (
                                    <span
                                      style={{
                                        color: "#a8a8a8",
                                        fontSize: isMobile ? "0.9rem" : "1rem",
                                      }}
                                    >
                                      {t("sortBy")}
                                    </span>
                                  );
                                }
                                return selected === "area"
                                  ? "📏 Area: Low To High"
                                  : selected === "-area"
                                    ? "📏 Area: High To Low"
                                    : selected === "amount"
                                      ? "💰 Amount: Low To High"
                                      : selected === "-amount"
                                        ? "💰 Amount: High To Low"
                                        : "Default";
                              }}
                            >
                              <MenuItem
                                disabled
                                value=""
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                <em>{t("sortBy")}</em>
                              </MenuItem>
                              <MenuItem
                                value={""}
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                {t("default")}
                              </MenuItem>
                              <MenuItem
                                value={"area"}
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                📏 {t("sortArea1")}
                              </MenuItem>
                              <MenuItem
                                value={"-area"}
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                📏 {t("sortArea2")}
                              </MenuItem>
                              <MenuItem
                                value={"amount"}
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                💰 {t("sortAmount1")}
                              </MenuItem>
                              <MenuItem
                                value={"-amount"}
                                sx={{ fontSize: isMobile ? "0.9rem" : "1rem" }}
                              >
                                💰 {t("sortAmount2")}
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>

                      {/* Show Results Button */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          mt: isMobile ? 3 : 4,
                        }}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            backgroundImage: colors.button,
                            width: "100%",
                            borderRadius: 2,
                            fontFamily: fonts.poppins,
                            padding: isMobile ? "6px 16px" : "8px 20px",
                            fontSize: isMobile ? "0.9rem" : size.formLabel,
                            textTransform: "none",
                          }}
                          onClick={() => {
                            handleShowResult();
                            setOpen(false);
                          }}
                        >
                          {t("showResult")}
                        </Button>
                      </Box>
                    </Paper>
                  </Fade>
                )}
              </Popper>
            </Box>
            {navigator.onLine && plots.length === 0 && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center", // Changed from "flex-start" to "center"
                  textAlign: "center",
                  animation: "fadeIn 0.5s ease-in-out",
                  height: "100vh", // This ensures full viewport height
                  width: "5000vw", // Optional: ensures full viewport width
                  // position: "fixed",        // Ensures it stays centered regardless of other content
                  // top: 0,
                  // left: 0,
                }}
              >
                <Box
                  component="img"
                  src="NoPlotFound.png"
                  alt="No Document Found"
                  sx={{ width: 250, height: "auto" }} // Added margin bottom for spacing
                />
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontWeight: 700,
                    fontSize: "24px",
                  }}
                >
                  {t("sorry")}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontWeight: 400,
                    color: colors.text,
                    fontSize: "16px",
                  }}
                >
                  {t("sorryWeHaventFound")}
                </Typography>
              </Box>
            )}

            <Grid container sx={{ justifyContent: "flex-end", margin: "16px" }}>
              <Grid item>
                <Box
                  sx={{ display: "flex", flexDirection: "row", gap: 0.5 }}
                  onClick={handleClick("bottom-end")}
                >
                  <Tune
                    sx={{ color: colors.primary_dark, cursor: "pointer" }}
                  />
                  <Typography
                    sx={{
                      fontFamily: fonts.poppins,
                      fontWeight: 600,
                      color: colors.primary_dark,
                      cursor: "pointer",
                    }}
                  >
                    {t("filter")}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ px: isMobile ? 2 : 4, pb: 8 }}>
            <Grid container spacing={4} sx={{ justifyContent: "center" }}>
            {plots.length === 0
              ? // Skeleton for placeholder cards
                Array.from({ length: 6 }).map((_, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card
                      sx={{
                        borderRadius: "24px",
                        background: colors.background,
                        border: "1px solid #E0E5EB",
                        display: "flex",
                        flexDirection: "column",
                        height: "400px",
                      }}
                    >
                      <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={220}
                        sx={{ borderRadius: "24px 24px 0 0" }}
                      />
                      <CardContent>
                        <Skeleton variant="text" width="60%" height={30} />
                        <Skeleton variant="text" width="40%" height={20} />
                        <Skeleton variant="text" width="80%" height={20} sx={{ mt: 2 }} />
                        <Skeleton variant="rectangular" width="100%" height={48} sx={{ borderRadius: "12px", mt: 3 }} />
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              : // Actual cards
                plots.map((plot, index) => (
                  <Grid item xs={12} sm={6} md={4} key={plot._id}>
                    <UnifiedCropCard
                      crop={plot}
                      userData={userData}
                      onGetContact={handleGetContact}
                      onDetails={(p) => {
                        setSelectedPlot(p);
                        setShowDetails(true);
                        setOpenPopup(true);
                      }}
                      onDeleteSuccess={(id) => {
                        setPlots(plots.filter(p => p._id !== id));
                      }}
                      onEdit={handleEditPlot}
                      onBoost={() => handleAssignSponsoredHours(plot)}
                      isAdmin={userData?.email === `${admin}`}
                      onToggleEnable={handleDisable}
                    />
                  </Grid>
                ))}
            </Grid>
            <Dialog
              open={openLogin}
              onClose={handleClose}
              fullWidth
              maxWidth="md"
              PaperProps={{
                sx: {
                  width: isMobile ? "90%" : "50%", // Adjust width dynamically
                  maxWidth: isMobile ? "100%" : "600px", // Ensure a maximum width
                  height: "auto",
                  maxHeight: "90vh",
                  margin: "auto",
                  overflow: "auto",
                  borderRadius: isMobile ? 3 : 5, // Adjust border radius for mobile
                  padding: isMobile ? 2 : 4, // Add padding for better spacing
                },
              }}
            >
              {/* Close Icon Button */}
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: isMobile ? 5 : 10,
                  top: isMobile ? 5 : 10,
                  zIndex: 1,
                  color: "gray",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
              >
                <Close />
              </IconButton>

              {/* Logo and Welcome Message */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: isMobile ? 3 : 5,
                }}
              >
                <img
                  src={`${KrushiSetu}`}
                  alt="logo"
                  style={{ width: isMobile ? 150 : 250 }} // Scale logo size for mobile
                />
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontWeight: 600,
                    fontSize: isMobile ? 24 : 30,
                    color: colors.primary_dark,
                    textAlign: "center",
                  }}
                >
                  {t("t&cWelcome")}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: isMobile ? 14 : size.subtitle,
                    textAlign: "center",
                  }}
                >
                  {t("home-title")}
                </Typography>
              </Box>

              {/* Signup Form */}
              <DialogContent
                sx={{
                  overflowY: "auto",
                  maxHeight: "70vh",
                  padding: isMobile ? 2 : 3,
                }}
              >
                <SignUp onClose={handleClose} />
              </DialogContent>
            </Dialog>

            <ContactPopup
              open={openPopup}
              onClose={() => {
                setIsChange(!isChange);
                setOpenPopup(false);
                setSelectedPlot(null);
              }}
              contactNumber={selectedPlot?.contactNumber}
            />
          </Box>

          {openSponsoredHoursPopup && (
            <>
              <SponsoredHoursPopup
                open={openSponsoredHoursPopup}
                onClose={() => setOpenSponsoredHoursPopup(false)}
                user={userData}
                plot={selectedPlot}
                onUpdateUser={handleUpdateUser}
              />
            </>
          )}
          <Modal open={openEditModal} onClose={handleCloseEditModal}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%", // Reduced from 60%
                maxWidth: 800, // Reduced from 800
                backgroundColor: colors.background3,
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                p: 2, // Reduced padding from p:3
                outline: "none",
              }}
            >
              {/* Compact Header with timestamps */}
              {/* <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  alignItems: { xs: "flex-start", sm: "center" },
                  gap: 0.5, // Reduced gap
                  marginBottom: 2, // Reduced from 3
                  paddingBottom: 1, // Reduced from 2
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: "0.8125rem", // Slightly smaller (13px)
                    color: "#555",
                    lineHeight: 1.3,
                  }}
                >
                  <strong>Created:</strong>{" "}
                  {new Date(plots.createdAt).toLocaleString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: "0.8125rem", // Slightly smaller (13px)
                    color: "#555",
                    lineHeight: 1.3,
                  }}
                >
                  <strong>Updated:</strong>{" "}
                  {new Date(plots.updatedAt).toLocaleString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Typography>
              </Box> */}

              {/* Edit Plot Component - Make sure EditPlot component also has compact styling */}
              <Box sx={{ maxHeight: "60vh", overflowY: "auto" }}>
                <EditPlot
                  plot={editPlot}
                  onClose={handleCloseEditModal}
                  onUpdate={handleUpdatePlot}
                />
              </Box>
            </Box>
          </Modal>
          {pageData?.pageCount > 1 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                margin: isMobile ? 2 : 4,
                "& .MuiPaginationItem-root": {
                  fontSize: isMobile ? "0.75rem" : "0.875rem",
                  minWidth: isMobile ? 32 : 40,
                  height: isMobile ? 32 : 40,
                },
                "& .MuiPagination-ul": {
                  flexWrap: "nowrap",
                },
              }}
            >
              <Pagination
                count={pageData?.pageCount}
                variant={isMobile ? "text" : "outlined"}
                shape="rounded"
                onChange={handleChange}
                page={page}
                siblingCount={isMobile ? 0 : 1}
                boundaryCount={isMobile ? 1 : 2}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default ListPlots;
